import React from 'react';
import { handleWhatsAppClick } from '../../../utils/trackPhoneCall';
import { siteConfig } from '../../../config/site';

const FloatingWhatsApp: React.FC = () => {
  const phone = siteConfig.phone;
  const msg = encodeURIComponent('Olá! Gostaria de pedir um orçamento.');
  const href = `https://wa.me/${phone}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      onClick={handleWhatsAppClick}
      className="fixed z-50 bottom-5 right-5 bg-[#25D366] hover:bg-[#1EBE5A] text-white shadow-lg rounded-full w-14 h-14 flex items-center justify-center transition-colors"
    >
      <i className="ri-whatsapp-line text-2xl" />
    </a>
  );
};

export default FloatingWhatsApp;


